<script lang="ts">
import { checkForUpdates } from "./utils/updater";
import { defineComponent } from "vue";
import { checkVersion } from "version-rocket";
import { ElConfigProvider, ElMessageBox } from "element-plus";
// import { ReDialog } from "@/components/ReDialog";
// import { ReDrawer } from "@/components/ReDrawer";
import en from "element-plus/es/locale/lang/en";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import plusEn from "plus-pro-components/es/locale/lang/en";
import plusZhCn from "plus-pro-components/es/locale/lang/zh-cn";
import { ElOverlay } from "element-plus";
import { useUserStore } from "./store/modules/user";
import { emitter } from "@/utils/emitter";
import { notificationUpdate } from "./api/system";
import { isDesktopDevice } from "./utils/deviceDetection";
import { useTranslationLang } from "./layout/hooks/useTranslationLang";
import { transformI18n } from "./plugins/i18n";

export default defineComponent({
  name: "app",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    // ReDialog,
    // ReDrawer,
    ElOverlay
  },
  data() {
    return {
      newUserDialogVisible: false,
      noticeId: ""
    };
  },
  computed: {
    currentLocale() {
      // Assuming you have a storage utility
      return this.$storage.locale?.locale === "zh-CN"
        ? { ...zhCn, ...plusZhCn }
        : { ...en, ...plusEn };
    }
  },
  beforeCreate() {
    const { version, name: title } = __APP_INFO__.pkg;
    const { VITE_PUBLIC_PATH, MODE } = import.meta.env;
    if (MODE === "production") {
      checkVersion(
        {
          pollingTime: 300000,
          localPackageVersion: version,
          originVersionFileUrl: `${location.origin}${VITE_PUBLIC_PATH}version.json`
        },
        {
          title,
          description: "检测到新版本",
          buttonText: "立即更新"
        }
      );
    }
  },
  mounted() {
    // 启动后延迟 3 秒检查，避免影响启动速度
    setTimeout(checkForUpdates, 3000);
    const { t } = useTranslationLang();
    // 监听权益弹窗开启事件
    emitter.on("openPrivilegeDialog", ({ id }) =>
      this.handleOpenPrivilegeDialog(id)
    );
    // H5 页面（如充值米粒）专为移动端设计，无需提示使用电脑访问
    const isH5Route = () =>
      /\/h5\//.test(this.$route?.path || window.location.hash);
    if (!isDesktopDevice() && !isH5Route()) {
      setTimeout(() => {
        if (isH5Route()) return;
        let msg = t("public.pleaseUseComputerForDomeKerBetterExperience");
        ElMessageBox.alert(msg, {
          showConfirmButton: false,
          showClose: false
        });
      }, 500);
    }
  },
  beforeUnmount() {
    emitter.off("openPrivilegeDialog", this.handleOpenPrivilegeDialog);
  },
  methods: {
    // 打开权益弹窗
    handleOpenPrivilegeDialog(id) {
      this.noticeId = id;
      this.newUserDialogVisible = true;
    },

    // 关闭新用户弹窗
    async handleCloseDialog(id) {
      this.newUserDialogVisible = false;
      await notificationUpdate(this.noticeId);
      this.noticeId = null;
      emitter.emit("updateNoticeList");
    }
  }
});
</script>

<template>
  <el-config-provider :locale="currentLocale">
    <router-view />
    <!-- <ReDialog /> -->
    <!-- <ReDrawer /> -->
  </el-config-provider>
  <!-- <el-overlay
    v-if="newUserDialogVisible"
    :mask="true"
    :z-index="2000"
    @click="handleCloseDialog"
  /> -->
  <!-- <transition name="new-user-zoom">
    <div v-if="newUserDialogVisible" class="new-user-dialog">
      <div class="new-user-title">新人注册赠送6米粒</div>
      <div class="new-user-title">免费体验直播一小时！</div>
      <img class="gift-img" src="@/assets/interests/gift.png" alt="" />
      <div class="new-user-content">
        <div class="setup-arrow-content">
          <div class="setup-arrow-item">
            <img src="@/assets/interests/setup1.png" alt="" class="setup-img" />
            <div class="setup-label">上百种多语种语音库</div>
          </div>
          <div class="setup-arrow-item">
            <img src="@/assets/interests/setup2.png" alt="" class="setup-img" />
            <div class="setup-label">免费音色</div>
          </div>
          <div class="setup-arrow-item">
            <img src="@/assets/interests/setup3.png" alt="" class="setup-img" />
            <div class="setup-label">无限直播间开播</div>
          </div>
          <div class="setup-arrow-item">
            <img src="@/assets/interests/setup4.png" alt="" class="setup-img" />
            <div class="setup-label">赠送6米粒</div>
          </div>
        </div>
        <div class="new-user-btn" @click="handleCloseDialog">
          <div class="new-user-btn-tips">赠送6米粒</div>
          <span>立即领取</span>
        </div>
      </div>
      <img
        class="new-user-close"
        src="@/assets/interests/close.png"
        alt=""
        @click="handleCloseDialog"
      />
    </div>
  </transition> -->
</template>
<style scoped>
code {
  background: var(--el-bg-color-page);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}
</style>

<style>
/* Scale Animation */
.dialog-scale-enter-active,
.dialog-scale-leave-active,
.dialog-scale-enter-active .el-dialog,
.dialog-scale-leave-active .el-dialog {
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.dialog-scale-enter-from,
.dialog-scale-leave-to {
  opacity: 0;
}

.dialog-scale-enter-from .el-dialog,
.dialog-scale-leave-to .el-dialog {
  transform: scale(0.5);
  opacity: 0;
}

/* Slide Animation */
.dialog-slide-enter-active,
.dialog-slide-leave-active,
.dialog-slide-enter-active .el-dialog,
.dialog-slide-leave-active .el-dialog {
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.dialog-slide-enter-from,
.dialog-slide-leave-to {
  opacity: 0;
}

.dialog-slide-enter-from .el-dialog,
.dialog-slide-leave-to .el-dialog {
  transform: translateY(-100px);
  opacity: 0;
}

/* Bounce Animation */
.dialog-bounce-enter-active,
.dialog-bounce-leave-active,
.dialog-bounce-enter-active .el-dialog,
.dialog-bounce-leave-active .el-dialog {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.dialog-bounce-enter-from,
.dialog-bounce-leave-to {
  opacity: 0;
}

.dialog-bounce-enter-from .el-dialog,
.dialog-bounce-leave-to .el-dialog {
  transform: scale(0.3) translateY(-50px);
  opacity: 0;
}

/* Object Configuration Animation */
.dialog-custom-object-enter-active,
.dialog-custom-object-leave-active,
.dialog-custom-object-enter-active .el-dialog,
.dialog-custom-object-leave-active .el-dialog {
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.dialog-custom-object-enter-from,
.dialog-custom-object-leave-to {
  opacity: 0;
}

.dialog-custom-object-enter-from .el-dialog,
.dialog-custom-object-leave-to .el-dialog {
  transform: rotate(180deg) scale(0.5);
  opacity: 0;
}
</style>
